import React from 'react'
import { Field } from 'redux-form'
import { Col, Button } from 'react-bootstrap'
import Form from 'components/Form'
import RadioField from 'components/RadioField'

export const ViewStatus = ({ ...props }) => {
	return <Col xs={12} md={8}>
		<h4>Danger Zone</h4>
		<p>If you switch off the game before the daily allocations are made, the system will stop right away.</p>
		<p>However, if you switch off the game after the daily allocations are made,
					the system will wait for the current daily cycle to finish. Then, the system will shut down from the next day.</p>
		<Form shouldShowSuccessMessage {...props}>
			<Field
				id='turned-on'
				name='status'
				label='Turn on'
				component={RadioField}
				type='radio'
				value='TURNED_ON'
			/>
			<Field
				id='turned-off'
				name='status'
				label='Turn off'
				component={RadioField}
				type='radio'
				value='TURNED_OFF'
			/>
			<div className='mt mb'>
				<Button type='submit' bsStyle='primary'>Save</Button>
			</div>
		</Form>
	</Col>
}

export default ViewStatus




// WEBPACK FOOTER //
// ./src/routes/Settings/components/ViewStatus.js